var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminApiCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7368 0H2.10526C0.947368 0 0 1.02273 0 2.27273V18.1818H2.10526V2.27273H14.7368V0ZM17.8947 4.54545H6.31579C5.15789 4.54545 4.21053 5.56818 4.21053 6.81818V22.7273C4.21053 23.9773 5.15789 25 6.31579 25H17.8947C19.0526 25 20 23.9773 20 22.7273V6.81818C20 5.56818 19.0526 4.54545 17.8947 4.54545ZM17.8947 22.7273H6.31579V6.81818H17.8947V22.7273Z",
    fill: "var(--fill-0, #009BE5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminApiCopyIcon);
export default __webpack_public_path__ + "static/media/AdminApiCopyIcon.0989621c1a40b50aab579395cc253324.svg";
export { ForwardRef as ReactComponent };